/* THE LINEN ROOM - theme scripts */
(function () {
  'use strict';
  function TT(k, d) { return (window.TLR_T && window.TLR_T[k]) || d; }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (!b) return;
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    var open = nav.classList.toggle('open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    var h = e.target.closest('.acc-h');
    if (!h) return;
    var item = h.parentElement;
    var group = item.parentElement;
    var wasOpen = item.classList.contains('open');
    group.querySelectorAll('.acc-i').forEach(function (x) {
      x.classList.remove('open');
      var pm = x.querySelector('.pm');
      if (pm) pm.textContent = '+';
      var hh = x.querySelector('.acc-h');
      if (hh) hh.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      var pm2 = item.querySelector('.pm');
      if (pm2) pm2.textContent = '−';
      h.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    /* In de winkelmand (updates[]) mag het aantal naar 0 (= verwijderen) en wordt de winkelmand direct bijgewerkt */
    var isCart = input.name === 'updates[]';
    var min = isCart ? 0 : 1;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v += b.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(min, v);
    if (isCart && input.form) {
      b.disabled = true;
      input.form.submit();
    }
  });

  var bar = document.getElementById('buybar');
  if (bar) {
    var atc = document.getElementById('pdp-atc');
    var onScroll = function () {
      if (!atc) return;
      bar.classList.toggle('show', atc.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    bar.querySelectorAll('[data-buybar-submit]').forEach(function (el) {
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        var form = document.getElementById('pdp-form');
        if (!form) return;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  var root = document.querySelector('[data-product-root]');
  if (root) {
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    } catch (err) { variants = []; }

    var priceEl = root.querySelector('[data-price]');
    var comparEl = root.querySelector('[data-compare]');
    var idEl = root.querySelector('[data-variant-id]');
    var btn = root.querySelector('[data-add]');
    var stockEl = root.querySelector('[data-stock]');
    var barPrice = document.querySelector('[data-bar-price]');
    var barOpts = document.querySelector('[data-bar-opts]');

    function fmt(cents) {
      var n = (cents / 100).toFixed(2).split('.');
      n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€ ' + n[0] + ',' + n[1];
    }

    function update() {
      var opts = Array.prototype.map.call(root.querySelectorAll('[data-opt-group]'), function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });

      root.querySelectorAll('[data-opt-group]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        var out = g.querySelector('[data-opt-value]');
        if (c && out) out.textContent = c.value;
      });

      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = TT('unavailable', 'Niet beschikbaar'); }
        return;
      }

      if (idEl) idEl.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (comparEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparEl.textContent = fmt(match.compare_at_price);
          comparEl.hidden = false;
        } else { comparEl.hidden = true; }
      }
      if (barPrice) barPrice.textContent = fmt(match.price);
      if (barOpts) barOpts.textContent = match.title;

      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? TT('add_to_cart', 'In winkelmand') + ' — ' + fmt(match.price) : TT('sold_out', 'Uitverkocht');
      }
      if (stockEl) {
        stockEl.classList.toggle('out', !match.available);
        var sp = stockEl.querySelector('span');
        if (sp) sp.textContent = match.available ? (stockEl.dataset.inStock || '') : (stockEl.dataset.outStock || '');
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-opt-group]')) update();
    });
    update();
  }
})();
